import React from 'react';
import PropTypes from 'prop-types';
import styles from './StatusProgress.module.scss';
import classNames from 'classnames';
import { useTranslation } from '../../i18n/LanguageProvider';

const StatusProgress = (props) => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <div className={styles.status}>
        <span className={styles.title}>{t('common.statusLabel')}</span>
        <span className={styles.value}>{props.label}</span>
      </div>
      <div className={styles.progress}>
        <div
          className={classNames(styles.done, {
            [styles.cancel]: props.current === -1
          })}
          style={{ width: `${(props.current / props.steps) * 100}%` }}
        />
      </div>
    </div>
  );
};

StatusProgress.propTypes = {
  label: PropTypes.string,
  current: PropTypes.number,
  step: PropTypes.number,
  steps: PropTypes.number
};

export default StatusProgress;
